<template>
  <div v-bind="$attrs"
       class="cell"
       :class="{ 'cell--no-gap': noGap }"
  >
    <div v-if="!noTitle && !hideTitle"
         class="cell--title"
         :class="{ 'flex-column': isColumn }"
    >
      <div class="cell--title__wrapper"
           style="height: 16px"
      >
        <slot name="caption">
          <div :class="['cell--caption', { 'cell--disabled': disabled }, captionClass]"
               :style="captionStyle"
          >
            {{ caption }}
          </div>
        </slot>
        <div v-if="required"
             class="cell--caption red"
        >
          *
        </div>
      </div>
      <div :class="['cell--desc', { 'cell--disabled': disabled }, descClass]"
           :style="descStyle"
           :title="desc"
      >
        {{ desc }}
      </div>
    </div>
    <div v-bind="$attrs"
         :class="['cell--content', { 'cell--disabled': disabled }, contentClass]"
         :style="contentStyle"
    >
      <slot />
    </div>
  </div>
</template>

<script setup>

defineProps({
  caption: {
    type: String,
    default: '',
  },
  desc: {
    type: String,
    default: '',
  },
  required: {
    type: Boolean,
    default: () => false,
  },
  disabled: {
    type: Boolean,
    default: () => false,
  },
  noTitle: {
    type: Boolean,
    default: () => false,
  },
  hideTitle: {
    type: Boolean,
    default: () => false,
  },
  noGap: {
    type: Boolean,
    default: () => false,
  },
  isColumn: {
    type: Boolean,
    default: () => false,
  },
  // Text customization props
  captionStyle: {
    type: Object,
    default: () => ({}),
  },
  captionClass: {
    type: [String, Array, Object],
    default: () => '',
  },
  descStyle: {
    type: Object,
    default: () => ({}),
  },
  descClass: {
    type: [String, Array, Object],
    default: () => '',
  },
  contentStyle: {
    type: Object,
    default: () => ({}),
  },
  contentClass: {
    type: [String, Array, Object],
    default: () => '',
  },
});
</script>

<style lang="scss" scoped>
.red {
  color: red;
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.cell--no-gap {
  gap: 0;
}

.cell--desc {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  color: rgba(14, 14, 34, 0.8);
}

// .cell--caption {
//   color: rgba(14, 14, 34, 0.4);
//   font-family: Inter;
//   font-size: 15px;
//   font-style: normal;
//   font-weight: 500;
//   line-height: 120%;
// }</style>
